import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { environment } from '../../environments/environment';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AlbumsService extends BaseService {
  override baseUrl = `${environment.apiUrl}/university-content/photo-albums`;

  override get(params: any = {}) {
    let httpParams = new HttpParams();

    for (const key in params) {
      if (params[key]) {
        httpParams = httpParams.set(key, params[key]);
      }
    }

    return this.http.get<any>(`${this.baseUrl}/photos`, {
      params: httpParams
    });
  }
}
